import script from "./privacyPolicy.vue?vue&type=script&setup=true&lang=js"
export * from "./privacyPolicy.vue?vue&type=script&setup=true&lang=js"

import "./privacyPolicy.vue?vue&type=style&index=0&id=5b435247&lang=less&scoped=true"

import exportComponent from "D:\\CODE\\joyjobs_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b435247"]])

export default __exports__